const availableChars = {
  lowers: 'abcdefghijklmnopqrstuvwxyz',
  uppers: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  digits: '0123456789',
  specials: "~!@#$%^&()_+-={}[];',",
};

// const generators = {
//     all: { pattern: /./ },
//     numeric: { pattern: /[0-9]/ },
//     alphanumeric: { pattern: /[0-9A-Za-z]/ },
//     hex: { pattern: /[0-9a-f]/ },
//     alpha: { pattern: /[a-zA-Z]/ },
// };

interface RandomIDParams {
  len?: number;
  length?: number;
  pattern?: RegExp;
  prefix?: string;
  suffix?: string;
  chars?: string;
  divider?: string;
}

const randomId = (params: RandomIDParams = {}) => {
  const len = params.len || params.length || 16;
  const pattern = params.pattern;
  const prefix = params.prefix || null;
  const suffix = params.suffix || null;
  let chars = (
    params.chars || availableChars.lowers.concat(availableChars.uppers, availableChars.digits)
  ).split('');

  // defining a pattern wins over params.chars
  if (pattern) {
    chars = [];
    availableChars.lowers
      .concat(availableChars.uppers, availableChars.digits, availableChars.specials)
      .split('')
      .forEach((c) => {
        if (pattern.test(c)) {
          chars.push(c);
        }
      });
  }

  let result = '';
  const divider = typeof params.divider === 'undefined' ? '_' : params.divider;

  if (prefix) {
    result += `${prefix}${divider}`;
  }

  for (let i = 0; i < len; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }

  if (suffix) {
    result += `${divider}${suffix}`;
  }

  return result;
};

export default randomId;
